import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Col from '../../utils/StyledCol'
import Row from '../../utils/StyledRow'
import WidgetContainer from '../../containers/WidgetContainer'
import ArticleImageBox from './StyledArticleImageBox'
import TextRow from './StyledArticleTextRow'
import ArticleList from './StyledArticleList'
import ArticleListBox from './StyledArticleListBox'
import ImageOverlayIcon from '../../utils/StyledImageOverlayIcon'
import UTM from '../../utils/UTM'

const BBX_ARTICLE_TYPE_ICONS = {
  gallery: 'galleryIcon',
  video: 'videoIcon'
}

class Articles extends PureComponent {
  render () {
    const {
      titleComponent: TitleComponent,
      vertical,
      isOpening,
      widget,
      widget: {
        boxes,
        imageCount,
        imageSize,
        utmContent,
        utmMedium,
        utmSource
      }
    } = this.props

    if (!boxes.length) {
      return null
    }

    const textBoxes = Object.assign([], boxes)
    const headBoxes = textBoxes.splice(0, imageCount)
    const headBoxSize = !(12 % imageCount) ? 12 / imageCount : 3 // FIXME: replace 3 with something more sensible if needed

    return (
      <WidgetContainer widget={widget} isOpening={isOpening}>
        {
          headBoxes.length > 0 &&
          <Row>
            {
              headBoxes.map(box => {
                const imagePath = box.images[imageSize]
                const image = (imagePath.indexOf('http://') === -1 && imagePath.indexOf('https://') === -1)
                  ? `${UNVERSIONED_STATICS_PATH}${box.images[imageSize]}`
                  : box.images[imageSize]

                const link = new UTM(box.link).getUTMLink({
                  utmContent,
                  utmMedium,
                  utmSource,
                  utmTerm: `position-${boxes.indexOf(box)}`,
                  utmCampaign: box.source
                })

                const boxWithImageAndLink = Object.assign({}, box, {
                  image,
                  link
                })

                return (
                  <Col sm={headBoxSize} key={box.guid}>
                    <ArticleImageBox
                      box={boxWithImageAndLink} imageClass={`image-${imageSize}`}
                      className={vertical ? 'vertical' : ''}>
                      {
                        BBX_ARTICLE_TYPE_ICONS.hasOwnProperty(boxWithImageAndLink.type) &&
                        <ImageOverlayIcon className={BBX_ARTICLE_TYPE_ICONS[boxWithImageAndLink.type]}/>
                      }
                      <TitleComponent box={boxWithImageAndLink}/>
                    </ArticleImageBox>
                  </Col>
                )
              })
            }
          </Row>
        }
        {
          textBoxes.length > 0 &&
          <TextRow>
            <Col sm={12}>
              <ArticleList>
                {
                  textBoxes.map(box => {
                    const link = new UTM(box.link).getUTMLink({
                      utmContent,
                      utmMedium,
                      utmSource,
                      utmTerm: `position-${boxes.indexOf(box)}`,
                      utmCampaign: box.source
                    })

                    const boxWithLink = Object.assign({}, box, {
                      link
                    })

                    return (
                      <ArticleListBox box={boxWithLink} key={box.guid} featuredClass='inline'/>
                    )
                  })
                }
              </ArticleList>
            </Col>
          </TextRow>
        }
      </WidgetContainer>
    )
  }
}

Articles.propTypes = {
  isOpening: PropTypes.bool,
  titleComponent: PropTypes.func.isRequired,
  vertical: PropTypes.bool,
  widget: PropTypes.object.isRequired
}

export default Articles
